import React, { FC } from 'react';
import { AllieVanillaTooltipContainer, AllieVanillaTooltipContent } from './VanillaTooltip.styles';

// Component

// Types
export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right';
export type TooltipTheme = 'light' | 'dark';
interface AllieVanillaTooltipProps {
  children: React.ReactNode;
  triggerElement: React.ReactNode;
  position?: TooltipPosition;
  theme?: TooltipTheme;
}

export const AllieVanillaTooltip: React.FC<AllieVanillaTooltipProps> = ({
  children,
  triggerElement,
  position = 'top',
  theme = 'light',
}) => {
  return (
    <>
      <AllieVanillaTooltipContainer>
        {triggerElement}
        <AllieVanillaTooltipContent className="tooltipContent" position={position} theme={theme}>
          {children}
        </AllieVanillaTooltipContent>
      </AllieVanillaTooltipContainer>
    </>
  );
};
